import { createContext } from "react";
const ChatUIContext = createContext({});
export { ChatUIContext };
